/**
 * 权限判断工具
 * 统一维护“平台管理员”的判断逻辑，供侧边栏菜单与路由守卫使用
 */

/**
 * 获取当前登录用户信息
 * @returns {Object} 用户信息对象；解析失败时返回空对象
 */
export function getUserInfo() {
  try {
    return JSON.parse(sessionStorage.getItem('userInfo') || '{}') || {}
  } catch (e) {
    return {}
  }
}

/**
 * 判断当前登录用户是否为平台管理员（userType 3）
 * @returns {boolean} 是否为平台管理员
 */
export function isPlatformAdminUser() {
  // 用户类型：0：个人用户 1：企业管理员 2：企业员工 3：平台管理员
  return getUserInfo()?.userType == 3
}
